import {
  Box,
  Button,
  ButtonProps,
  Icons,
  Text,
  TextArea,
  TextAreaProps,
  styled,
} from '@/theme/index';

export const QuestionContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(0.5),
  alignItems: 'center',
  marginBottom: theme.spacing(1),
}));

export const Question = styled(Text)(({ theme }) => ({
  fontWeight: 'bold',
  marginBottom: theme.spacing(1),
}));

export const AnswerContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(4),
}));

export const ErrorContainer = ({ message, ...props }: { message: string }) => (
  <Box marginTop={-3} marginBottom={1}>
    <Text
      variant="caption"
      color="error"
      fontSize="small"
      margin={0}
      {...props}
    >
      {message}
    </Text>
  </Box>
);

export const OptionButton = styled((props: ButtonProps) => (
  <Button variant="outlined" size="small" {...props} />
))(({ theme }) => ({
  [theme.breakpoints.up('sm')]: {
    minWidth: '120px',
  },
  [theme.breakpoints.up('md')]: {
    minWidth: '210px',
  },
}));

export const TextAreaAnswer = styled((props: TextAreaProps) => (
  <TextArea size="small" fullWidth {...props} />
))(({ theme }) => ({
  flexGrow: 1,
  [theme.breakpoints.up('sm')]: {
    minWidth: '120px',
  },
  [theme.breakpoints.up('md')]: {
    minWidth: '210px',
  },
}));

export const CommentAgreement = () => (
  <Text variant="body2" display="flex" alignItems="center">
    <Icons.FormatQuote sx={{ mr: 0.5 }} />
    By posting a comment, you agree to strictly abide by our Terms, including
    posting no objectionable language.
  </Text>
);
